module.exports = __webpack_public_path__ + "img/bill2.f22d3969.png";